/**
 * Minimal `**bold**` splitter for single-line copy fields (section intros).
 *
 * Full markdown is deliberately out of scope — these fields are plain
 * sentences where dealers occasionally want a bold lead ("**We're totally
 * stoked!** That's why…"). The renderer maps bold segments to <strong>.
 * Unmatched `**` markers pass through as literal text.
 */
export type BoldSegment = { text: string; bold: boolean }

const BOLD_RE = /\*\*([^*]+)\*\*/g

export function splitBoldSegments(text: string): BoldSegment[] {
  const out: BoldSegment[] = []
  let last = 0
  for (const m of text.matchAll(BOLD_RE)) {
    if (m.index > last) out.push({ text: text.slice(last, m.index), bold: false })
    out.push({ text: m[1], bold: true })
    last = m.index + m[0].length
  }
  if (last < text.length) out.push({ text: text.slice(last), bold: false })
  return out
}
